import React from 'react';
import styled from 'styled-components';

import { AccountDetails } from './components/account-details';
import { DefaultHeader } from './components/default-header';
import { SiteSelectorForm } from './components/site-selector-form';

import { fontFamily } from '@atlaskit/theme';

export type SiteSelectorViewProps = {
  readonly userName: string;
  readonly userEmail: string;
  readonly sites: string[];

  readonly header?: React.ReactNode;

  readonly onNewSiteSelected: () => void;
  readonly onSiteSelected: (site: string) => void;
  readonly onSiteChanged: () => void;
  readonly onSwitchAccountClick: () => void;
  readonly onCancelClick: () => void;

  readonly avatarSrc?: string;
  readonly fullScreenView?: boolean;
};

export function SiteSelectorView({
  userName,
  userEmail,
  sites,
  avatarSrc,
  header,
  onNewSiteSelected,
  onSiteSelected,
  onSwitchAccountClick,
  onCancelClick,
  onSiteChanged,
  fullScreenView
}: SiteSelectorViewProps) {
  return (
    <RootContainer>
      <Header>{header !== undefined ? header : <DefaultHeader />}</Header>
      <AvatarContainer>
        <AccountDetails
          userName={userName}
          userEmail={userEmail}
          avatarSrc={avatarSrc}
        />
      </AvatarContainer>
      <SitesContainer>
        <SiteSelectorForm
          sites={sites}
          onNewSiteSelected={onNewSiteSelected}
          onSiteSelected={onSiteSelected}
          onSwitchAccountClick={onSwitchAccountClick}
          onCancelClick={onCancelClick}
          onSiteChanged={onSiteChanged}
          fullScreenView={fullScreenView}
        />
      </SitesContainer>
    </RootContainer>
  );
}

const RootContainer = styled.div`
  font-family: ${fontFamily};
`;

const Header = styled.div`
  font-family: Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
`;

const AvatarContainer = styled.div`
  margin: 20px 0px;
`;

const SitesContainer = styled.div``;
